import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../../../types"
import { getServiceErrorMessage } from "../../../helpers"

export const assignSubjectToClassesTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    id: "assignSubjectToClasses",
    // TODO: Invoke service.
    src: () => {
      return Promise.resolve()
    },
    onDone: {
      target: "#StudyPlan.teacher_view.idle"
      // TODO: Update context with data.
      // actions: assign<Context, DoneInvokeEvent<any>>({})
    },
    onError: {
      target: "#StudyPlan.teacher_view.idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("assignSubjectToClasses", {
            messageData: ["assign subject to classes"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
